import uniqueValues from "@arcgis/core/smartMapping/statistics/uniqueValues";
//https://developers.arcgis.com/javascript/latest/api-reference/esri-rest-support-StatisticDefinition.html


export async function queryFeaturesOverLimit(mapFeatureLayer, query) {
    //let totalCount = await mapFeatureLayer.queryFeatureCount(query)
    //console.log(totalCount)
    let i = true
    let counter = 0 
    let featuresArr = []
    while (i === true){
        let index =  {num:5000 , start: (counter*5000)}
        let tempQuer = query
        let indexedquery = Object.assign(tempQuer, index)
        let results;
        try {
          results = await mapFeatureLayer.queryFeatures(indexedquery);
        } catch (err) {
          console.error('queryFeatures failed, layer:', mapFeatureLayer, 'query:', indexedquery, 'error:', err);
          return featuresArr;
        }
        
        if (results && results.features && results.features.length) {
          featuresArr.push(...results.features);
        }
        //console.log(results.features)
        if (!results || results.features.length < 5000) {
          return featuresArr;
        }
        counter++;
    }
}

export async function queryFeaturesOverLimit2k(mapFeatureLayer, query, mapContext) {

    let i = true
    let counter = 0 
    let featuresArr = []
    while (i === true){
        let index =  {num:2000 , start: (counter*2000)}
        let tempQuer = query
        let indexedquery = Object.assign(tempQuer, index)

        let results;
        try {
          results = await mapFeatureLayer.queryFeatures(indexedquery);
        } catch (err) {
          mapContext.dispatch({
              error: errorHandler(err),
          });
          console.error('queryFeatures failed, layer:', mapFeatureLayer, 'query:', indexedquery, 'error:', err);
          return featuresArr;
        }

        if (results && results.features && results.features.length) {
          featuresArr.push(...results.features);
        }

        if (!results || results.features.length < 2000) {
          return featuresArr;
        }
        counter++;
    }
}

function errorHandler(error) {
  if (error.message?.includes("Syntax error")) {
    return "Sintaksės klaida užklausoje";
  } else if (error == "TypeError: mapFeatureLayer.queryFeatures is not a function") {
    return "Klaida: netinkamas sluoksnis";
  } else if (error.message?.includes("Unable to complete operation")){
    return "Netinkama užklausa. Bandykite dar kartą"
  } else if (error.message?.includes("Timeout")){
    return "Pasirinktas per didelis kiekis duomenų. Bandykite sumažindi duomenų aprėpti ir/ar laikotarpį."
  } else {
    return "Nežinoma klaida";
  }
}

export function toISOLocal(d) {
    if (d === null) {
      return
    }
    var z  = n =>  ('0' + n).slice(-2);
    var zz = n => ('00' + n).slice(-3);
    var off = d.getTimezoneOffset();
    var sign = off > 0? '-' : '+';
    off = Math.abs(off);
  
    return d.getFullYear() + '-'
           + z(d.getMonth()+1) + '-' +
           z(d.getDate()) + 'T' +
           z(d.getHours()) + ':'  + 
           z(d.getMinutes()) + ':' +
           z(d.getSeconds()) + '.' +
           zz(d.getMilliseconds()) +
           sign + z(off/60|0) + ':' + z(off%60); 
}


export function checkOneDayApartAndTransform(inputString) {
    // Task 1: Check if timestamps are one day apart
    function isOneDayApart(str) {
      if (!str) return false; // Handle null input
  
      const dateRegex = /timestamp'(\d{2}\/\d{2}\/\d{4})/g;
      const matches = [...str.matchAll(dateRegex)]; // Extract all date matches
  
      if (matches.length < 2) return false; // Ensure two dates are found
  
      const date1 = new Date(matches[0][1]);
      const date2 = new Date(matches[1][1]);
  
      const diffInDays = Math.abs(date2 - date1) / (1000 * 60 * 60 * 24);
      return diffInDays === 1; // Return true if exactly one day apart
    }
  
    // Task 2: Transform 'datetime' to 'pubmillis'
    function transformString(str) {
      return str ? str.replaceAll('datetime', 'pubmillis') : null;
    }
  
    // Perform both actions and return results
    return {
      isOneDayApart: isOneDayApart(inputString),
      transformedString: transformString(inputString),
    };
  }

  export function transformString(str, orgInput, transformTo) {
    if (!str) return null; // Handle null or undefined input
  
    const regex = new RegExp(orgInput, 'g');
    return str.replace(regex, transformTo);
  }
  
  export function generateDateScoreFilterFromString(dateRangeString) {


      const rx = /datetime\s*(>=|<)\s*(timestamp|date)\s*'([^']+)'/gi;
      const matches = [...dateRangeString.matchAll(rx)];

      if (matches.length < 2) {
        throw new Error("Could not find both dates in: " + dateRangeString);
      }

      // Pakeisti formata is dd/mm/yyyy i yyyy-mm-dd
      const isoFirst    = convertToISO(matches[0][3]);          
      const isoSecond   = convertToISO(matches[1][3]);

      // Grazinti prieda filtrui kuris atfiltruoja osm tinklo negaliojancius duomenis
      return (
        `AND (valid_from < timestamp'${isoFirst}') ` +
        `AND (valid_to IS NULL OR valid_to >= timestamp'${isoSecond}')`
      );
  }

  function convertToISO(arcgisReturned) {
    const [datePart, timePart = "00:00:00"] = arcgisReturned.trim().split(/\s+/);

    // day, month, year
    const [dd, mm, yyyy] = datePart.split(/[-/.]/).map(Number);
    if (!yyyy || !mm || !dd) {
      throw new Error("Bad date: " + arcgisReturned);
    }

    // hour, minute, second
    const [HH = 0, MI = 0, SS = 0] = timePart.split(":").map(Number);

    const pad = (n) => String(n).padStart(2, "0");
    return `${yyyy}-${pad(mm)}-${pad(dd)} ${pad(HH)}:${pad(MI)}:${pad(SS)}`;
  }

  export function calculatePercentagesFromTotal(numbers, total) {
    //console.log(numbers)
    let percentages = numbers.map(num => parseFloat((num / total * 100).toFixed(1)));

    const discrepancy = 100 - percentages.reduce((sum, perc) => sum + perc, 0);

    if (discrepancy !== 0) {
        const indexToAdjust = percentages.findIndex(num => num === Math.max(...percentages));
        percentages[indexToAdjust] += discrepancy;
    }

    return percentages;
}

export function transoprationAvailableDatesParam(mapContext) {   
  if (mapContext.state.transportation.toLowerCase() ===  "car") {
    return "date_str"
  }
  else if (mapContext.state.transportation.toLowerCase() ===  "bus") {
    return "dates_vt"
  }
  else if (mapContext.state.transportation.toLowerCase() ===  "pedestrian") {
    return "dates_pedestrians"
  }
  else if (mapContext.state.transportation.toLowerCase() ===  "bike") {
    return "dates_bikes"
  } else {
    return "date_str"
  }
}

export async function availableDatesQuery(mapContext, operatorAvailableDates) {
    let dateParam = transoprationAvailableDatesParam(mapContext)

      uniqueValues({
        layer: operatorAvailableDates,
        field: dateParam,
      }).then(function (response) {
        // prints each unique value and the count of features containing that value
        let infos = response.uniqueValueInfos;
        let availableDatesLocal = [];
        let parsedDates = [];
        infos.forEach(function (info) {

          if (!availableDatesLocal.includes(info.value) && info.value != null) {
            let splitDate = info.value.split('/')
            let addDate = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
            parsedDates.push(addDate);
            availableDatesLocal.push(info.value);
          }
        });
      //("parsedDates")
      //(parsedDates)
        return parsedDates
        
      });

}
  

  